import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import useDeviceDetect from 'utils/useDeviceDetect';

// styles
import './style.scss';

// layout components
import ErrorBoundary from 'engine/ErrorBoundary';

// antd component
import { Input, Button } from 'antd';

// assets
import CustomIcons from 'components/CustomIcons';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';

function SearchForm({
  uniqueKey,
  value,
  loading,
  // switch state
  show,
  setShow,
  allowClear,
  // actions
  onSearch,
  onClick,
  onChange,
  onClose,
  onClear,
  // default props
  className,
}) {
  const childClassNames = classNames('search-form-extra', className);
  //const { isMobile } = useDeviceDetect();
  const searchRef = useRef(null);

  const [currentValue, setCurrentValue] = useState(value || '');

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  useEffect(() => {
    if (currentValue.length > 0 && show && (loading || !loading)) {
      searchRef.current.focus({
        cursor: 'end',
      });
    }
  }, [loading, show]);

  const onClickIcon = useCallback((e) => {
    !!setShow && setShow(prev => !prev);
    searchRef.current.focus({
      cursor: 'start',
    });
    !!onClick && onClick(e);
  }, [onClick, searchRef]);

  const onCloseSearch = useCallback((e) => {
    !!setShow && setShow(prev => !prev);
    setCurrentValue('');
    !!onClose && onClose(currentValue);
  }, [onClose]);

  const onSearchCallback = useCallback(
    (searchBy, e) => {
      setCurrentValue(searchBy);
      if (!searchBy) {
        !!onClose && onClose(searchBy);
      }
      !!onSearch && onSearch(searchBy);
    },
    [setCurrentValue],
  );

  const onChangeCallback = useCallback(
    e => {
      const searchBy = e.target.value;
      setCurrentValue(searchBy);
      if (onChange !== undefined) {
        onChange(searchBy, e);
      }
    },
    [setCurrentValue],
  );

  const render = useMemo(
    () => (
      <>
        <CustomIcons
          className={`search-extra__icon search-icon ${(!show || currentValue?.length > 0) ? 'show' : ''
            } ${loading ? 'disabled' : ''}`}
          onClick={onClickIcon}
          type="search"
        />
        <span className={`search-form-extra__bar ${show ? 'show' : ''}`}>
          <Input.Search
            key="search-form-extra"
            name="search-form-extra"
            size="large"
            placeholder="Recherche..."
            loading={loading}
            enterButton={true}
            allowClear={!!allowClear && {
              clearIcon: <CloseOutlined />,
            }}
            prefix={
              <>
                {!loading && <CloseOutlined onClick={onCloseSearch} />}
              </>
            }
            onSearch={onSearchCallback}
            onChange={onChangeCallback}
            value={currentValue}
            ref={searchRef}
          />
        </span>
      </>
    ),
    [currentValue, value, searchRef, loading, show],
  );

  return (
    <div key={`search-by-list-${uniqueKey}`} className={childClassNames}>
      <ErrorBoundary>
        {render}
      </ErrorBoundary>
    </div>
  );
}

SearchForm.defaultProps = {
  uniqueKey: 'simple',
  loading: false,
  show: false,
  allowClear: true
};
SearchForm.propTypes = {
  uniqueKey: PropTypes.string,
  onSearch: PropTypes.func,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
};

export default SearchForm;
